/**
 * Derive the caller's Orari viewer role from auth + loaded policies.
 *   admin   → super-user
 *   manager → dept manager of at least one department
 *   member  → employee in an active rotation policy (not excluded)
 *   none    → not a participant — Orari must not appear in nav
 */
export function deriveViewerRole({ auth, policies, departments }) {
  const user = auth?.user || {};
  const employee = auth?.employee || null;
  const userRole = (auth?.userRole || user.userRole || "").toLowerCase();
  if (
    userRole === "admin" ||
    userRole === "administrator" ||
    userRole === "super admin" ||
    userRole === "branch manager"
  ) {
    return { role: "admin" };
  }
  const userSub = user.userSub;
  const identityId = user.identityId;

  const managedDepartmentIds = (departments || [])
    .filter(
      (d) =>
        d?.departmentManagerId &&
        (d.departmentManagerId === userSub ||
          d.departmentManagerId === identityId)
    )
    .map((d) => d.departmentId);
  if (managedDepartmentIds.length > 0) {
    return { role: "manager", managedDepartmentIds };
  }

  if (!employee) return { role: "none" };

  const myPolicy = (policies || []).find(
    (p) =>
      p.departmentId === employee.employeeDepartmentId &&
      p.status !== "archived"
  );
  if (!myPolicy) return { role: "none", employee };

  const myRule = (myPolicy.roleRules || []).find(
    (r) =>
      r.roleId === employee.employeeRoleId ||
      r.roleName === employee.employeeRoleName
  );
  const excluded = (myPolicy.excludedEmployeeIds || []).includes(
    employee.employeeId
  );
  if (!myRule || myRule.mode === "excluded" || excluded) {
    return { role: "none", employee };
  }
  return { role: "member", employee, policy: myPolicy };
}

export function canAccessOrari(viewer) {
  return viewer?.role === "admin" ||
    viewer?.role === "manager" ||
    viewer?.role === "member";
}
